/* eslint-disable camelcase */
import { useTranslation } from 'react-i18next';
import { getDeviceType } from '@app/utils';
import { useTrackEvents } from '@data/utils/events';

export const useDiseaseSearchAnalytics = (enabled: boolean) => {
  const { i18n } = useTranslation();
  const { events, trackEvent } = useTrackEvents();

  const getCommonAttributes = () => ({
    language: i18n.language,
    device_type: getDeviceType(),
    timestamp: new Date().toISOString(),
  });

  const trackDiseaseSearchPopupOpened = () => {
    if (!enabled) return;

    trackEvent(events.DiseaseSearchPopupOpened, {
      ...getCommonAttributes(),
    });
  };

  // The disease (name or ICD code) and the typed search text are health data
  // and stay in the app. GTM only learns that a selection happened.
  const trackDiseaseSearchDiseaseSelected = () => {
    if (!enabled) return;

    trackEvent(events.DiseaseSearchDiseaseSelected, getCommonAttributes());
  };

  const trackDiseaseSearchDiseaseNotFound = () => {
    if (!enabled) return;

    trackEvent(events.DiseaseSearchDiseaseNotFound, getCommonAttributes());
  };

  const trackDiseaseSearchContactOpened = () => {
    if (!enabled) return;

    trackEvent(events.DiseaseSearchContactOpened, getCommonAttributes());
  };

  const trackDiseaseSearchContactSent = () => {
    if (!enabled) return;

    trackEvent(events.DiseaseSearchContactSent, getCommonAttributes());
  };

  const trackDiseaseSearchContactEmailCopied = () => {
    if (!enabled) return;

    trackEvent(events.DiseaseSearchContactEmailCopied, getCommonAttributes());
  };

  return {
    trackDiseaseSearchPopupOpened,
    trackDiseaseSearchDiseaseSelected,
    trackDiseaseSearchDiseaseNotFound,
    trackDiseaseSearchContactOpened,
    trackDiseaseSearchContactSent,
    trackDiseaseSearchContactEmailCopied,
  };
};
